import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const TabContainer = styled.div `
  display: flex;
  gap: 0;
  margin-bottom: 32px;
  border-bottom: 1px solid var(--border-color);
`;
const TabButton = styled.button `
  padding: 16px 32px;
  background: ${props => props.$active ? 'var(--bg-tertiary)' : 'transparent'};
  color: ${props => props.$active ? 'var(--text-primary)' : 'var(--text-tertiary)'};
  border: none;
  border-bottom: ${props => props.$active ? '2px solid var(--accent-color)' : '2px solid transparent'};
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    color: var(--text-primary);
    background: var(--bg-tertiary);
  }
`;
export const Tabs = ({ tabs, activeTab, onTabChange }) => {
    return (_jsx(TabContainer, { children: tabs.map(tab => (_jsx(TabButton, { "$active": activeTab === tab.id, onClick: () => onTabChange(tab.id), children: tab.label }, tab.id))) }));
};
